import { Link, useNavigate } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import Toaster from "../../components/toaster"
import { useEffect, useState } from "react"
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
import { onlyDigits, isValidAadhar, isValidMobile, profileError } from "../../utils/profileRules";

const MyProfile = () => {
    const isMobileView = useIsMobile();
    const [profileDetails, setProfileDetails] = useState()
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [deleting, setDeleting] = useState(false)
    // "Same as primary number" for the Aadhaar-linked mobile
    const [linkedIsPrimary, setLinkedIsPrimary] = useState(false)
const navigate = useNavigate();
    const getMyProfile = async () => {
        try {
            const response = await services.Vendor.GET_VENDOR();
            if (response.data) {
                setProfileDetails(response.data);
                const linked = response.data.VendorDetail?.aadharLinkedPhoneNumber;
                setLinkedIsPrimary(!!linked && linked === response.data.phoneNumber);
            }
        } catch (error) {
            console.log(error)
        }
    }
    const HandleOnChangeValue = (e, key, type) => {
        let obj = { ...profileDetails }
        if (type) {
            obj[key] = e;
        } else {
            obj.VendorDetail[key] = e;
        }

        setProfileDetails({ ...obj })
    }
    useEffect(() => {
        getMyProfile();
    }, [])
    const toggleLinkedIsPrimary = (checked) => {
        setLinkedIsPrimary(checked);
        HandleOnChangeValue(checked ? profileDetails?.phoneNumber || '' : '', 'aadharLinkedPhoneNumber');
    };
    const onSubmitHandler = async () => {
        const problem = profileError(profileDetails?.VendorDetail);
        if (problem) {
            setToaster({ type: "danger", title: "Complete your profile", text: problem, visiblity: "show" });
            setTimeout(() => setToaster({ visiblity: "hide" }), 4000);
            return;
        }
        try {
            let data = {
                userData: {
                    firstName: profileDetails.firstName,
                    lastName: profileDetails.lastName,
                    phoneNumber: profileDetails.phoneNumber,
                    email: profileDetails.email
                },
                vendorData: {
                    aadharLinkedPhoneNumber: profileDetails.VendorDetail.aadharLinkedPhoneNumber,
                    aadharNumber: profileDetails.VendorDetail.aadharNumber,
                }
            }
            const response = await services.Vendor.UPDATE_VENDOR(data)
            setToaster({
                type: "success",
                title: "Login",
                text: 'Profile Updated successfully',
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
                navigate('/')
            }, 3000)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error",
                text: error.response.data.message,
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 60000)
        }
    }
    const deleteAccountHandler = async () => {
        setDeleting(true)
        try {
            await services.Vendor.DELETE_ACCOUNT();
            setToaster({
                type: "success",
                title: "Account Deleted",
                text: 'Your account has been deleted successfully',
                visiblity: "show",
            });
            setTimeout(() => {
                localStorage.clear();
                window.location.replace('/login');
            }, 1200)
        } catch (error) {
            console.log(error)
            setDeleting(false)
            setShowDeleteConfirm(false)
            setToaster({
                type: "danger",
                title: "Could not delete account",
                text: error.response?.data?.message || "Failed to delete account",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 4000)
        }
    }

    if (isMobileView) {
        const vd = profileDetails?.VendorDetail || {};
        const approved = vd.approvalStatus === 'approved';
        // Approved partners can't change verified details, but can still fix a missing/invalid one
        const lockAadhar = approved && isValidAadhar(vd.aadharNumber);
        const lockLinked = approved && isValidMobile(vd.aadharLinkedPhoneNumber);
        const stColor = approved ? '#16a34a' : vd.approvalStatus === 'rejected' ? '#ef4444' : '#f59e0b';
        const initials = `${(profileDetails?.firstName || '').charAt(0)}${(profileDetails?.lastName || '').charAt(0)}`.toUpperCase();
        const logout = () => { localStorage.clear(); window.location.replace('/login'); };
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/" className="mlux-avatar"><i className="fas fa-gauge-high"></i></Link>} />
                    <div className="mlux-phero" data-rise="1">
                        <div className="pic">{initials || <i className="far fa-user"></i>}</div>
                        <div className="nm2">{profileDetails?.firstName || 'Your name'} {profileDetails?.lastName || ''}</div>
                        <div className="ph">+91 {profileDetails?.phoneNumber || '—'}</div>
                        <span className="mlux-pill" style={{ background: `${stColor}1a`, color: stColor, marginTop: 8 }}>{vd.approvalStatus || 'pending'}</span>
                    </div>

                    <div className="mlux-card" style={{ padding: 16, marginTop: 16 }} data-rise="2">
                        <div className="mlux-row">
                            <div><label className="mlux-lbl">First name</label><div className="mlux-field no-icon"><input type="text" value={profileDetails?.firstName || ''} placeholder="First name" onChange={(e) => HandleOnChangeValue(e.target.value, 'firstName', 'user')} /></div></div>
                            <div><label className="mlux-lbl">Last name</label><div className="mlux-field no-icon"><input type="text" value={profileDetails?.lastName || ''} placeholder="Last name" onChange={(e) => HandleOnChangeValue(e.target.value, 'lastName', 'user')} /></div></div>
                        </div>
                        <label className="mlux-lbl">Phone (locked)</label>
                        <div className="mlux-field no-icon"><input type="number" value={profileDetails?.phoneNumber || ''} disabled readOnly /></div>
                        <label className="mlux-lbl">Email</label>
                        <div className="mlux-field no-icon"><input type="email" value={profileDetails?.email || ''} placeholder="Email" onChange={(e) => HandleOnChangeValue(e.target.value, 'email', 'user')} /></div>
                        <label className="mlux-lbl">Aadhaar number <span style={{ color: '#ef4444' }}>*</span>{lockAadhar ? ' (locked)' : ''}</label>
                        <div className="mlux-field no-icon"><input type="tel" inputMode="numeric" value={vd.aadharNumber || ''} disabled={lockAadhar} placeholder="12-digit Aadhaar" onChange={(e) => HandleOnChangeValue(onlyDigits(e.target.value, 12), 'aadharNumber')} /></div>
                        <label className="mlux-lbl" style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 600, textTransform: 'none', letterSpacing: 0 }}>
                            <input type="checkbox" checked={linkedIsPrimary} disabled={lockLinked} onChange={(e) => toggleLinkedIsPrimary(e.target.checked)} style={{ width: 18, height: 18, accentColor: 'var(--accent)' }} />
                            Same as primary number
                        </label>
                        <label className="mlux-lbl">Aadhaar-linked mobile <span style={{ color: '#ef4444' }}>*</span>{lockLinked ? ' (locked)' : ''}</label>
                        <div className="mlux-field no-icon"><input type="tel" inputMode="numeric" value={vd.aadharLinkedPhoneNumber || ''} disabled={lockLinked || linkedIsPrimary} placeholder="10-digit mobile" onChange={(e) => HandleOnChangeValue(onlyDigits(e.target.value, 10), 'aadharLinkedPhoneNumber')} /></div>


                        <button className="mlux-btn" style={{ marginTop: 16 }} onClick={onSubmitHandler}><i className="far fa-circle-check"></i> Save changes</button>
                    </div>

                    <button className="mlux-btn ghost" style={{ marginTop: 12 }} onClick={logout}><i className="far fa-arrow-right-from-bracket"></i> Log out</button>

                    {!showDeleteConfirm
                        ? <button className="mlux-danger" onClick={() => setShowDeleteConfirm(true)}><i className="far fa-trash-can"></i> Delete account</button>
                        : <div className="mlux-confirm">
                            <p>Delete your partner account permanently? Your cars and one-way availabilities will be removed. This can't be undone.</p>
                            <div className="row2">
                                <button className="cancel" disabled={deleting} onClick={() => setShowDeleteConfirm(false)}>Cancel</button>
                                <button className="yes" disabled={deleting} onClick={deleteAccountHandler}>{deleting ? 'Deleting…' : 'Delete'}</button>
                            </div>
                        </div>}
                </main>
                <MobileFooter />
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />
            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div >
                                                <h4 class="user-profile-card-title d-flex justify-content-between">Profile Info <span class={`badge text-capitalize badge-${profileDetails?.VendorDetail?.approvalStatus == 'approved' ? 'success' : 'danger'}`}>{profileDetails?.VendorDetail?.approvalStatus}</span></h4>

                                            </div>
                                            <div class="user-profile-form">

                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>First Name</label>
                                                            <input onChange={(e) => HandleOnChangeValue(e.target.value, 'firstName', 'user')} type="text" class="form-control" value={profileDetails?.firstName}
                                                                placeholder="First Name" />
                                                                {!profileDetails?.firstName && <small className="text-danger">First Name required</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Last Name</label>
                                                            <input onChange={(e) => HandleOnChangeValue(e.target.value, 'lastName', 'user')} type="text" class="form-control" value={profileDetails?.lastName}
                                                                placeholder="Last Name" />
                                                                {!profileDetails?.lastName && <small className="text-danger">Last Name required</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Phone Number</label>
                                                            <input disabled={true} onChange={(e) => HandleOnChangeValue(e.target.value, 'phoneNumber', 'user')} type="number" class="form-control"
                                                                value={profileDetails?.phoneNumber} placeholder="Phone number" />
                                                                {profileDetails?.phoneNumber?.length > 10 && <small className="text-danger">Please enter valid phone number</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Aadhaar Number <span className="text-danger">*</span></label>
                                                            <input disabled={profileDetails?.VendorDetail?.approvalStatus == 'approved' && isValidAadhar(profileDetails?.VendorDetail?.aadharNumber)}  onChange={(e) => HandleOnChangeValue(onlyDigits(e.target.value, 12), 'aadharNumber')} type="tel" inputMode="numeric" class="form-control"
                                                                value={profileDetails?.VendorDetail?.aadharNumber || ''} placeholder="12-digit Aadhaar" />
                                                                {profileDetails?.VendorDetail?.aadharNumber && !isValidAadhar(profileDetails.VendorDetail.aadharNumber) && <small className="text-danger">Aadhaar must be exactly 12 digits</small>}
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label className="d-flex align-items-center gap-2 mb-1" style={{ fontWeight: 500 }}>
                                                                <input type="checkbox" checked={linkedIsPrimary} disabled={profileDetails?.VendorDetail?.approvalStatus == 'approved' && isValidMobile(profileDetails?.VendorDetail?.aadharLinkedPhoneNumber)} onChange={(e) => toggleLinkedIsPrimary(e.target.checked)} />
                                                                Same as primary number
                                                            </label>
                                                            <label>Aadhaar-linked Mobile <span className="text-danger">*</span></label>
                                                            <input disabled={linkedIsPrimary || (profileDetails?.VendorDetail?.approvalStatus == 'approved' && isValidMobile(profileDetails?.VendorDetail?.aadharLinkedPhoneNumber))} onChange={(e) => HandleOnChangeValue(onlyDigits(e.target.value, 10), 'aadharLinkedPhoneNumber')} type="tel" inputMode="numeric" class="form-control"
                                                                value={profileDetails?.VendorDetail?.aadharLinkedPhoneNumber || ''} placeholder="10-digit mobile" />
                                                                {profileDetails?.VendorDetail?.aadharLinkedPhoneNumber && !isValidMobile(profileDetails.VendorDetail.aadharLinkedPhoneNumber) && <small className="text-danger">Enter a 10-digit mobile number</small>}
                                                        </div>
                                                    </div>
                                              
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Email</label>
                                                            <input type="email" class="form-control"
                                                                onChange={(e) => HandleOnChangeValue(e.target.value, 'email','user')} value={profileDetails?.email} placeholder="Email" />
                                                        </div>
                                                    </div>
                                            

                                                </div>
                                                <button type="button" onClick={onSubmitHandler} class="theme-btn my-3"><span
                                                    class="far fa-user"></span> Save Changes</button>

                                                <div class="border-top mt-4 pt-4">
                                                    <h5 class="text-danger">Delete account</h5>
                                                    <p class="text-muted mb-3">Permanently delete your partner account. Your cars and one-way availabilities will be removed. This can't be undone.</p>
                                                    <button type="button" class="btn btn-outline-danger" onClick={() => setShowDeleteConfirm(true)}>
                                                        <i class="far fa-trash-can me-2"></i>Delete Account
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />

        {showDeleteConfirm && (
            <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete account?</h5>
                        </div>
                        <div className="modal-body">
                            <p className="mb-0">Your partner account, cars and one-way availabilities will be removed permanently. This can't be undone.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" disabled={deleting} onClick={() => setShowDeleteConfirm(false)}>Cancel</button>
                            <button type="button" className="btn btn-danger" disabled={deleting} onClick={deleteAccountHandler}>{deleting ? 'Deleting…' : 'Delete Account'}</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </>
    )
}
export default MyProfile